import { displayMessage } from "./utils";

export function startZendeskChat(wrapper) {
  displayMessage(wrapper, "Connecting to live chat...", "info");
}

// Retrieves the Zendesk chat data from the DOM
// Returns null if no data is found or if parsing fails
function getZendeskData() {
  const element = document.querySelector('.zendesk-data')
  if (!element || !element.dataset.zendesk) return null;

  try {
    return JSON.parse(element.dataset.zendesk);
  } catch (e) {
    console.error("Failed to parse Zendesk data", e);
    return null;
  }
}
